import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const points = ['Te despertás a la madrugada a controlar si tu hijo respira bien.', 'Revisás cada comida con miedo a que algo dispare una crisis.', 'Los fármacos controlan parcialmente, pero sus efectos secundarios también te preocupan.', 'Te dijeron “hay que esperar”, pero nadie te explicó qué más podés hacer desde casa.', 'Gastaste en consultas y suplementos que solo te dieron respuestas parciales.'];
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-84" data-mp="2204kjf9sxf84">
      <div className="mx-auto max-w-4xl" data-id="element-85" data-mp="1nzts47sufsku">
        <header className="text-center" data-id="element-86" data-mp="1o14sdxn2yi77">
          <h2 className="font-display text-3xl font-bold sm:text-5xl" style={{
          fontSize: "24px"
        }} data-id="element-87" data-mp="1syn6s3jv9pml">
            ¿Cuánto tiempo más vas a vivir con el miedo de que la próxima crisis
            llegue hoy?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300" data-id="element-88" data-mp="3nd7k1v5uyivy">
            Sos una madre que lo da todo. Buscás respuestas, sostenés cada
            rutina y no te rendís. Pero hasta ahora, nadie te dio el mapa
            correcto para ordenar lo que sí podés hacer todos los días.
          </p>
          <p className="mt-4 font-semibold text-brand-light" data-id="element-89" data-mp="27ti92s1a2yvq">
            No es falta de esfuerzo. Es que te faltaba un sistema claro.
          </p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-90" data-mp="23trcg7p2loja">
          {points.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-91" data-mp="1g2cf6tc5hxew" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-92" data-mp="30he3fq3dkepc" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-93" data-mp="2vitfap1edlh9">
                {point}
              </p>
            </motion.div>)}
        </div>
        <p className="mt-12 text-center font-display text-2xl font-bold italic text-brand-gold sm:text-3xl" data-id="element-94" data-mp="1t4vkcjzvwoq9">
          ¿Y si pudieras tener un mapa claro para ayudar a reducir la carga
          inflamatoria desde hoy mismo?
        </p>
      </div>
    </section>;
}